var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-container full-height" },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            top: "5%",
            visible: _vm.dialogMemberFormVisible,
            title: "審核-" + _vm.roleSettingObj.email,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogMemberFormVisible = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("p", [
                    _vm._v("申請時間：" + _vm._s(_vm.roleSettingObj.buildDate)),
                  ]),
                  _c("p", [
                    _vm._v(" email：" + _vm._s(_vm.roleSettingObj.email) + " "),
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v(_vm._s(_vm.isOk ? "尚未註冊" : "已註冊")),
                    ]),
                  ]),
                  _c("p", [_vm._v("姓名：" + _vm._s(_vm.roleSettingObj.name))]),
                  _vm.roleSettingObj.roles !== ""
                    ? _c("p", [
                        _vm._v("角色：" + _vm._s(_vm.roleSettingObj.roles)),
                      ])
                    : _vm._e(),
                  _c("el-input", {
                    staticStyle: { color: "black" },
                    attrs: { type: "textarea", rows: 10, disabled: "" },
                    model: {
                      value: _vm.roleSettingObj.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.roleSettingObj, "description", $$v)
                      },
                      expression: "roleSettingObj.description",
                    },
                  }),
                  _vm.newp != null && _vm.newp !== ""
                    ? _c(
                        "p",
                        [
                          _vm._v(" 已建立會員資料，預設密碼為"),
                          _c(
                            "el-tag",
                            {
                              staticStyle: { margin: "0 4px" },
                              attrs: { type: "danger" },
                            },
                            [_vm._v(_vm._s(_vm.newp))]
                          ),
                          _vm._v(
                            " 請注意，該密碼僅顯示一次，關閉視窗後無法查詢密碼! "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-steps",
                { attrs: { active: _vm.active, "finish-status": "success" } },
                [
                  _c("el-step", { attrs: { title: "步骤 1" } }),
                  _c("el-step", { attrs: { title: "步骤 2" } }),
                  _c("el-step", { attrs: { title: "步骤 3" } }),
                  _c("el-step", { attrs: { title: "步骤 4" } }),
                ],
                1
              ),
              _c("el-alert", { attrs: { type: "info", closable: false } }, [
                _vm._v("請注意，資料為一步一步建立，無返回上一步的操作!"),
              ]),
              _vm.active == 0
                ? [
                    _c("p", [
                      _vm._v(
                        "審核該申請者提交的內容之連結及簡介的正確性後，請點選審核結果進行下一步。"
                      ),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.verify(true)
                          },
                        },
                      },
                      [_vm._v("審核通過")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: {
                          click: function ($event) {
                            return _vm.verify(false)
                          },
                        },
                      },
                      [_vm._v("審核不通過")]
                    ),
                  ]
                : _vm.active == 1
                ? [
                    _vm.verifyResult
                      ? [
                          _vm.isOk
                            ? _c("p", [
                                _vm._v(
                                  " 該email尚未建立會員資料，選擇角色後送出將會自動建立會員資料，帳號為email，密碼為預設密碼。 "
                                ),
                              ])
                            : _vm._e(),
                          _c(
                            "el-table",
                            {
                              staticStyle: {
                                width: "100%",
                                margin: "20px 0px",
                              },
                              attrs: {
                                data: _vm.rolesList,
                                border: "",
                                fit: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "選取" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-checkbox",
                                            {
                                              attrs: {
                                                label: scope.row.roleCode,
                                              },
                                              model: {
                                                value: _vm.rolesSelected,
                                                callback: function ($$v) {
                                                  _vm.rolesSelected = $$v
                                                },
                                                expression: "rolesSelected",
                                              },
                                            },
                                            [_vm._v(" 選取 ")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2759007023
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "角色代碼" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.roleCode) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  243896740
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "角色名稱" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.roleName) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1840091566
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.saveData },
                            },
                            [_vm._v("確認")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: { click: _vm.closeDialog },
                            },
                            [_vm._v("取消")]
                          ),
                        ]
                      : _vm._e(),
                  ]
                : _vm.active == 2
                ? [
                    _vm.verifyResult
                      ? [
                          _c("el-alert", {
                            attrs: {
                              closable: false,
                              title: "此為向外公開的個人簡介資料",
                              type: "warning",
                            },
                          }),
                          _c(
                            "el-form",
                            {
                              ref: "introductionForm",
                              staticStyle: { margin: "20px 0px" },
                              attrs: {
                                rules: _vm.introRules,
                                size: "mini",
                                model: _vm.introObj,
                                "label-width": _vm.formLabelWidth,
                              },
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "頭貼",
                                    "label-width": _vm.formLabelWidth,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("Upload", {
                                        ref: "uploadRef",
                                        attrs: {
                                          accept: ".jpg,.jpeg,.png",
                                          payload: _vm.introObj,
                                          "limit-file-count": 1,
                                          limitText:
                                            "圖片尺寸:70x70，須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                                          "data-obj": _vm.fileObj,
                                          "use-drag": false,
                                          action:
                                            "ToursCombine/saveIntroAvatar",
                                          "auto-upload": false,
                                          "show-file-list": true,
                                          "form-on-loading-parent":
                                            _vm.listLoading,
                                          "btn-txt": "上傳",
                                          "before-file-list":
                                            _vm.introObj.fileInfo &&
                                            _vm.introObj.fileInfo.length
                                              ? _vm.introObj.fileInfo[0].files
                                              : [],
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "名稱", prop: "authorName" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "50",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.introObj.authorName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.introObj,
                                          "authorName",
                                          $$v
                                        )
                                      },
                                      expression: "introObj.authorName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "簡介",
                                    prop: "introduction",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      autosize: { minRows: 4, maxRows: 4 },
                                    },
                                    model: {
                                      value: _vm.introObj.introduction,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.introObj,
                                          "introduction",
                                          $$v
                                        )
                                      },
                                      expression: "introObj.introduction",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "排序", prop: "sort" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.introObj.sort,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.introObj, "sort", $$v)
                                      },
                                      expression: "introObj.sort",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._l(
                                _vm.introObj.socialLinkList,
                                function (social, index) {
                                  return _c(
                                    "el-form-item",
                                    {
                                      key: index,
                                      attrs: {
                                        label: "社群" + (index + 1),
                                        prop: "social." + index + ".id",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { placeholder: "請選擇" },
                                          model: {
                                            value: social.socialType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                social,
                                                "socialType",
                                                $$v
                                              )
                                            },
                                            expression: "social.socialType",
                                          },
                                        },
                                        _vm._l(
                                          _vm.socialLinkSelectList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      _c("el-input", {
                                        staticStyle: { width: "50%" },
                                        model: {
                                          value: social.url,
                                          callback: function ($$v) {
                                            _vm.$set(social, "url", $$v)
                                          },
                                          expression: "social.url",
                                        },
                                      }),
                                      _c(
                                        "el-button",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.removeSocialLink(
                                                social
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    { on: { click: _vm.addSocialLink } },
                                    [_vm._v("新增社群")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.saveIntroduction(
                                    "introductionForm"
                                  )
                                },
                              },
                            },
                            [_vm._v("確定")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: { click: _vm.closeDialog },
                            },
                            [_vm._v("取消")]
                          ),
                        ]
                      : _vm._e(),
                  ]
                : _vm.active == 3
                ? [
                    _c(
                      "div",
                      { staticStyle: { margin: "20px 0px" } },
                      [
                        _c("tinymce", {
                          ref: "tinymce",
                          attrs: { height: 500, type: 30 },
                          model: {
                            value: _vm.emailContent,
                            callback: function ($$v) {
                              _vm.emailContent = $$v
                            },
                            expression: "emailContent",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.saveEmail },
                      },
                      [_vm._v("寄送信件")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: { click: _vm.closeDialog },
                      },
                      [_vm._v("取消")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "full-height",
          staticStyle: { padding: "20px", "padding-bottom": "0" },
        },
        [
          _c(
            "div",
            { staticStyle: { "padding-bottom": "0" } },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "搜尋" } },
                    [
                      _c("el-input", {
                        attrs: { size: "mini", placeholder: "輸入Email查詢" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleFilter($event)
                          },
                        },
                        model: {
                          value: _vm.listQuery.qry,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "qry", $$v)
                          },
                          expression: "listQuery.qry",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            size: "mini",
                            type: "primary",
                            icon: "el-icon-search",
                          },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v(" 搜尋 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { position: "relative", height: "80%" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  key: _vm.tableKey,
                  attrs: {
                    size: "mini",
                    data: _vm.list,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    height: "100%",
                  },
                  on: { "sort-change": _vm.sortChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "ID",
                      prop: "id",
                      sortable: "custom",
                      align: "center",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.id))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Email",
                      prop: "email",
                      align: "left",
                      width: "250",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.email))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "姓名",
                      prop: "name",
                      sortable: "custom",
                      align: "center",
                      width: "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.name))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "建立時間",
                      sortable: "custom",
                      width: "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.buildDate))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "操作", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-edit",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.editData(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 審核 ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "刪除", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  icon: "el-icon-key",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteData(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 刪除 ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            staticStyle: { "padding-top": "0" },
            attrs: {
              total: _vm.total,
              page: _vm.listQuery.page,
              limit: _vm.listQuery.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.listQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.listQuery, "limit", $event)
              },
              pagination: _vm.getList,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }